/* offset-x | offset-y | blur-radius | spread-radius | color */
export const SHADOW_DEFAULT = '0 1px 4px 0 rgba(63, 65, 68, 0.3)';
export const SHADOW_FOCUSED = '0 2px 17px 0 rgba(63, 65, 68, 0.3)';
export const SUPER_SHADOW = '0 24px 36px 0 rgba(0, 0, 0, 0.08)';
export const SHADOW_DEFAULT_UP = '0 -1px 4px 0 rgba(63, 65, 68, 0.3)';
export const SHADOW_FOCUSED_UP = '0 -2px 17px 0 rgba(63, 65, 68, 0.3)';
export const SUPER_SHADOW_UP = '0 -24px 36px 0 rgba(0, 0, 0, 0.08)';
export const SHADOW_PRIMARY = '0 2px 6px 2px rgba(89, 221, 125, 0.4)';
export const SHADOW_PRIMARY_FOCUSED = '0 2px 17px 0 rgba(89, 221, 125, 0.6)';
export const SHADOW_ALARM = '0 2px 6px 2px rgba(236, 128, 128, 0.4)';
export const SHADOW_ALARM_FOCUSED = '0 2px 17px 0 rgba(236, 128, 128, 0.6)';
export const SHADOW_WARNING = '0 2px 6px 2px rgba(225, 118, 1, 0.4)';
export const SHADOW_WARNING_FOCUSED = '0 2px 17px 0 rgba(225, 118, 1, 0.6)';
const SHADOWS = {
  SHADOW_DEFAULT,
  SHADOW_FOCUSED,
  SUPER_SHADOW,
  SHADOW_DEFAULT_UP,
  SHADOW_FOCUSED_UP,
  SUPER_SHADOW_UP,
  SHADOW_PRIMARY,
  SHADOW_PRIMARY_FOCUSED,
  SHADOW_ALARM,
  SHADOW_ALARM_FOCUSED,
  SHADOW_WARNING,
  SHADOW_WARNING_FOCUSED
};
export default SHADOWS;